export default [
	{
		id: "mfa.active.token",
		name: "Ativação da autenticação Token MFA",
		tooltip: "Ativa ou desativa a autenticação Token MFA.",
		authorities: ["ROLE_ADMIN", "ROLE_TI"],
		value: null,
		valueConvert: (value) => {
			return value == "true" ? true : false;
		},
	},
];

